module.exports = __webpack_public_path__ + "img/cloud.31f1e143.png";